import _slicedToArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import { QuestionType } from '@module/form';
export var ShuffledFormItems = /*#__PURE__*/function () {
  function ShuffledFormItems() {
    _classCallCheck(this, ShuffledFormItems);
  }

  _createClass(ShuffledFormItems, null, [{
    key: "shuffle",
    value: function shuffle(items, shuffledQuestions) {
      /** Exclusive end index for the next section (after the last question of the previous section). */
      var nextSectionStartIndex;
      var newItems = shuffledQuestions.flatMap(function (filterShuffledQuestions) {
        var data = ShuffledFormItems.shuffleItems(items, filterShuffledQuestions, nextSectionStartIndex);

        if (data.length > 0) {
          var currentItem = data[data.length - 1];

          if (currentItem.type !== 'heading') {
            var questionItem = currentItem; // Use nextIndex when set (matching / fill-in-blank span multiple numbers); else single slot.

            var hasExclusiveEnd = questionItem.nextIndex != null && questionItem.nextIndex > questionItem.index;
            nextSectionStartIndex = hasExclusiveEnd ? questionItem.nextIndex : questionItem.index + 1;
          }
        }

        return data;
      });
      return newItems;
    }
    /**
     * Shuffle question order and answers only. Headings are re-interleaved by the
     * caller via Headings.sortWithQuestions so they stay with their question groups.
     */

  }, {
    key: "shuffleQuestions",
    value: function shuffleQuestions(questions, shuffledQuestions) {
      if (!(questions !== null && questions !== void 0 && questions.length) || !(shuffledQuestions !== null && shuffledQuestions !== void 0 && shuffledQuestions.length)) {
        return questions || [];
      }

      return this.shuffle(questions, shuffledQuestions).filter(function (item) {
        return item.type !== 'heading';
      });
    }
  }, {
    key: "shuffleItems",
    value: function shuffleItems(items, shuffledQuestion, currentWeightOfIndex) {
      var _this = this;

      var mapSortedFormItems = new Map(); // Add null/undefined check for shuffledQuestion

      if (!shuffledQuestion || !shuffledQuestion.questionIndexes) {
        return items; // Return original items if shuffledQuestion is invalid
      }

      var _loop = function _loop(index) {
        var item = items[index];

        if (item.type !== 'heading') {
          var formItem = shuffledQuestion.questionIndexes.find(function (indexItem) {
            var _indexItem$questionRe;

            var shuffledId = (_indexItem$questionRe = indexItem.questionReleaseId) === null || _indexItem$questionRe === void 0 ? void 0 : _indexItem$questionRe.split('#')[0];
            var questionId = item.id.toString().split('#')[0];
            return shuffledId === questionId;
          });

          if (formItem) {
            var _question = item;

            switch (_question.type) {
              case QuestionType.Matching:
                {
                  var _matchingQuestion = _question;
                  var _weight2 = _matchingQuestion.subQuestions.length;

                  _question.addIndex(formItem.index);

                  _question.addNextIndex(0);

                  _this.shuffleAnswers(_question, formItem.answerIndexes);

                  break;
                }

              case QuestionType.FillInBlank:
                {
                  var _fillInBlankQuestion = _question;
                  var _weight3 = _fillInBlankQuestion.answers.length;

                  _question.addIndex(formItem.index);

                  _question.addNextIndex(0);

                  break;
                }

              case QuestionType.SingleChoice:
              case QuestionType.MultipleChoice:
                {
                  _question.addIndex(formItem.index);

                  _question.addNextIndex(0);

                  _this.shuffleAnswers(_question, formItem.answerIndexes);

                  break;
                }

              default:
                {
                  _question.addIndex(formItem.index);

                  _question.addNextIndex(0);

                  break;
                }
            }

            mapSortedFormItems.set(formItem.index, _question);
          }
        } else {
          // Check if headingIndexes exists before accessing it
          if (shuffledQuestion.headingIndexes) {
            var headingItem = shuffledQuestion.headingIndexes.find(function (i) {
              return i.headingId === item.id.toString();
            });
            if (headingItem) mapSortedFormItems.set(headingItem.index, item);
          }
        }
      };

      for (var index = 0; index < items.length; index++) {
        _loop(index);
      }

      var sortedFormItems = Array.from(mapSortedFormItems.entries()).sort(function (_ref, _ref2) {
        var _ref3 = _slicedToArray(_ref, 1),
            a = _ref3[0];

        var _ref4 = _slicedToArray(_ref2, 1),
            b = _ref4[0];

        return a - b;
      }).map(function (_ref5) {
        var _ref6 = _slicedToArray(_ref5, 2),
            key = _ref6[0],
            value = _ref6[1];

        return value;
      });
      var weightOfIndex = -1;

      if (typeof currentWeightOfIndex === 'number') {
        weightOfIndex = currentWeightOfIndex;
      }

      var newSortedItems = [];

      for (var _index = 0; _index < sortedFormItems.length; _index++) {
        var item = sortedFormItems[_index];

        if (item.type !== 'heading') {
          var question = item;

          if (weightOfIndex === -1) {
            // Start question numbering from 1 for the first section.
            // Shuffled item positions can include headings and must not offset question numbers.
            weightOfIndex = 1;
          }

          switch (question.type) {
            case QuestionType.Matching:
              {
                var matchingQuestion = question;
                var weight = matchingQuestion.subQuestions.length;
                question.addIndex(weightOfIndex);
                question.addNextIndex(question.index + weight);
                weightOfIndex = question.index + weight;
                break;
              }

            case QuestionType.FillInBlank:
              {
                var fillInBlankQuestion = question;
                var _weight = fillInBlankQuestion.answers.length;
                question.addIndex(weightOfIndex);
                question.addNextIndex(question.index + _weight);
                weightOfIndex = question.index + _weight;
                break;
              }

            default:
              {
                question.addIndex(weightOfIndex);
                weightOfIndex++;
              }
          }

          newSortedItems.push(question);
        } else {
          newSortedItems.push(item);
        }
      }

      return newSortedItems;
    }
  }, {
    key: "shuffleAnswers",
    value: function shuffleAnswers(item, shuffledAnswerIndexes) {
      switch (item.type) {
        case QuestionType.MultipleChoice:
        case QuestionType.SingleChoice:
          {
            var question = item;
            var mapAnswers = new Map();

            var _loop2 = function _loop2(i) {
              var answer = question.answers[i];
              var foundShuffledItem = shuffledAnswerIndexes.find(function (s) {
                return s.answerId === answer.id.toString();
              });

              if (foundShuffledItem) {
                mapAnswers.set(foundShuffledItem.index, answer);
              }
            };

            for (var i = 0; i < question.answers.length; i++) {
              _loop2(i);
            }

            question.updateAnswers(Array.from(mapAnswers.entries()).sort(function (_ref7, _ref8) {
              var _ref9 = _slicedToArray(_ref7, 1),
                  a = _ref9[0];

              var _ref10 = _slicedToArray(_ref8, 1),
                  b = _ref10[0];

              return a - b;
            }).map(function (_ref11) {
              var _ref12 = _slicedToArray(_ref11, 2),
                  key = _ref12[0],
                  value = _ref12[1];

              return value;
            }));
            break;
          }

        case QuestionType.Matching:
          {
            var _question2 = item;
            var mapSubQuestions = new Map();

            var _loop3 = function _loop3(_i) {
              var subQuestion = _question2.subQuestions[_i];
              var foundShuffledItem = shuffledAnswerIndexes.find(function (s) {
                return s.answerId === subQuestion.id.toString();
              });

              if (foundShuffledItem) {
                mapSubQuestions.set(foundShuffledItem.index, subQuestion);
              }
            };

            for (var _i = 0; _i < _question2.subQuestions.length; _i++) {
              _loop3(_i);
            }

            _question2.updateSubQuestions(Array.from(mapSubQuestions.entries()).sort(function (_ref13, _ref14) {
              var _ref15 = _slicedToArray(_ref13, 1),
                  a = _ref15[0];

              var _ref16 = _slicedToArray(_ref14, 1),
                  b = _ref16[0];

              return a - b;
            }).map(function (_ref17) {
              var _ref18 = _slicedToArray(_ref17, 2),
                  key = _ref18[0],
                  value = _ref18[1];

              return value;
            }));

            break;
          }
      }
    }
  }]);

  return ShuffledFormItems;
}();